import React, { useEffect } from 'react'

function DetailSection({ data }) {
  const [activeTab, setActiveTab] = React.useState();
  const [activeData, setActiveData] = React.useState();
  useEffect(() => {
    if (data?.data?.length) {
      setActiveTab(data?.data[0]?.name)
      setActiveData(data?.data[0])

    }
  }, [data])
  return (
    <div className="ttm-row sidebar ttm-sidebar-left clearfix">
      <div className="container">
        {/* row */}
        <div className="row">
          <div className="col-lg-4 widget-area sidebar-left">
            <aside className="widget widget-nav-menu">
              <ul>
                {data?.data?.map((item, index) => {
                  return (
                    <li style={{ cursor: "pointer" }} key={index} className={`side_btn ${activeTab === item.name ? 'active' : ''}`} onClick={() => {
                      setActiveTab(item.name)
                      setActiveData(item)
                    }}><a>{item.name}</a></li>
                  )
                }
                )}
                {/* <li className="side_btn active" data-tab="Kitchen-Towels"><a> Kitchen Towels </a></li>
              <li className="side_btn" data-tab="Kitchen-Aprons"><a> Kitchen Aprons </a></li>
              <li className="side_btn" data-tab="Promotional-Kitchen"><a> Promotional Kitchen Textile</a></li>
              <li className="side_btn" data-tab="Pot-Holders"><a> Pot Holders &amp; Oven Mitts </a></li> */}
                {/* <li class="side_btn"><a data-tab="we-design-fabric-2" > Stich Fabric </a></li>
                            <li class="side_btn"><a data-tab="we-design-fabric"> We Design Fabric </a></li> */}
              </ul>
            </aside>
            <aside className="widget widget-banner">
              <div className="ttm-col-bgcolor-yes ttm-bgcolor-darkgrey col-bg-img-seven ttm-col-bgimage-yes ttm-bg">
                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                  <div className="ttm-col-wrapper-bg-layer-inner" />
                </div>
                <div className="layer-content">
                  <div className="widget-banner-inner">
                    <h3 className="ttm-textcolor-skincolor">Have Questions?</h3>
                    <p>Our client care managers are available 24/7 to assist you.</p>
                    <ul>
                      <li><i className="flaticon flaticon-phone-call" />+92 305 1115508</li>
                    </ul>
                  </div>
                </div>
              </div>
            </aside>
            <aside className="widget contact-widget with-title">
              <h3 className="widget-title">Get in touch</h3>
              <ul className="contact-widget-wrapper">
                <li><i className="ttm-textcolor-skincolor ti ti-location-pin" />Office # 2, 3rd Floor, 21-CCA, DHA 8 (Ex-Park View), Block D Cantt, Lahore, Pakistan</li>
                <li><i className="ttm-textcolor-skincolor ti ti-email" /><a href="mailto:sales@naskinternational.com" target="_blank">sales@naskinternational.com</a></li>
                <li><i className="ttm-textcolor-skincolor ti ti-mobile" />+92 305 1115508</li>
                <li><i className="ttm-textcolor-skincolor ti ti-alarm-clock" />Mon to Sat - 9:00am to 6:00pm <br /> (Sunday Closed)</li>
              </ul>
            </aside>
          </div>
          <div className="col-lg-8 content-area tab-box active-box">
            <div className="ttm-service-single-content-area">
              <div className="ttm-service-description">
                <h3>{activeData?.name}</h3>
                <p>{activeData?.description}</p>
                {activeData?.heading && <h4>{activeData?.heading}</h4>}
                {activeData?.peera && <p>{activeData?.peera}</p>}
                <div className="main-parent d-flex flex-wrap mt-4 mb-3" style={{ gap: '10px' }}>
                  {activeData?.product_list?.map((item, index) => {
                    return (
                      <div key={index} style={{ display: 'flex' }} className="coutem-code">
                        <div style={{ border: '1px solid', height: '14px', width: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5px', marginRight: '7px', borderRadius: '50px', color: '#2197D5' }} className="coutem-icon">+</div>
                        <p>{item}</p>
                      </div>
                    )
                  }
                  )}
                </div>
                <div className="padding_top20 padding_bottom20">
                  <div className="ttm_fatured_image-wrapper">
                    <img className="img-fluid" src={activeData?.image1} alt="services-1" />
                  </div>
                </div>
                <div className="padding_top15 padding_bottom5">
                  <h3>Key Features</h3>
                  <p>{activeData?.key_features_desc}</p>
                  <div className="row">
                    <div className="col-md-12">
                      <ul className="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor margin_top15 d-flex flex-wrap">
                        {activeData?.key_features_list?.map((item, index) => {
                          return (
                            <li key={index} className="w-50"><i className="ti ti-check" />
                              <div className="ttm-list-li-content">{item}</div>
                            </li>
                          )
                        })}

                      </ul>
                    </div>
                  </div>
                </div>
                <div className="padding_top30 padding_bottom15">
                  {/* <h3>Provide In-house trainings</h3> */}
                  <div className="row">
                    {activeData?.image2 && <div className="col-md-6 col-sm-6">
                      <div className="ttm_single_image-wrapper text-left padding_top15">
                        <img className="img-fluid" src={activeData?.image2} alt="single-img-10" />
                      </div>
                    </div>}
                    {activeData?.image3 && <div className="col-md-6 col-sm-6">
                      <div className="ttm_single_image-wrapper text-left padding_top15">
                        <img className="img-fluid" src={activeData?.image3} alt="single-img-11" />
                      </div>
                    </div>}
                  </div>
                </div>
                {/* <div class="padding_top30 mb_15">
                                <h3>Upgrade Your Kitchen with High-Quality Towels</h3>
                                <p>Investing in high-quality kitchen towels enhances both functionality and style in your kitchen. Premium towels made from absorbent fabrics like rayon ensure quick drying and effective cleaning, keeping your space tidy. Their durability allows for long-term use, making them a cost-effective choice. Soft yet strong, they protect delicate cookware while efficiently handling spills and messes. With a variety of colors and designs available, high-quality kitchen towels also add a touch of elegance to your kitchen décor.</p>
                            </div> */}
              </div>
            </div>
          </div>

        </div>{/* row end */}
      </div>
    </div>

  )
}

export default DetailSection